import axios from 'axios'
import { FieldValues, Path, UseFormSetError } from 'react-hook-form'

export function handleFormError<T extends FieldValues>(
  err: Error | null,
  setError: UseFormSetError<T>
): void {
  if (err) {
    if (axios.isAxiosError(err)) {
      const errors = err.response?.data as Record<string, string[]>
      if (errors && typeof errors === 'object') {
        Object.entries(errors).forEach(([key, value]) => {
          setError(key as Path<T>, {
            message: typeof value === 'string' ? value : value[0],
          })
        })
      }
    }
  }
}
